const homepageFallback = {
  seoModule: {
    title: "Experts4Europe | Faire Infrastruktur für internationale Fachkräfteeinwanderung",
    description:
      "Experts4Europe ist die strukturierte, faire und KI-gestützte Infrastruktur für internationale Fachkräfteeinwanderung nach Europa: Verifikation, Readiness, Matching und verantwortliche Arbeitgeber in einem System.",
    canonicalPath: "/",
    ogTitle: "Experts4Europe | Faire Infrastruktur für internationale Fachkräfteeinwanderung",
    ogDescription:
      "Nicht Jobportal, nicht Vermittlungsagentur, sondern ein verantwortliches System für Profil, Dokumente, Sprache, Matching, Filing und Ankommen in Europa.",
    },
    heroModule: {
      eyebrow: "Experts4Europe",
      title: "Die faire Infrastruktur für internationale Fachkräfteeinwanderung nach Europa.",
      titleLines: [
        "Die faire Infrastruktur",
        "für internationale",
        "Fachkräfteeinwanderung",
        "nach Europa.",
      ],
      lead:
        "Experts4Europe verbindet Profil, Dokumente, Sprache, Readiness, Matching und Arbeitgeberverantwortung in einem klaren System. Nicht als klassische Vermittlung, sondern als ruhige, belastbare und KI-gestützte Infrastruktur für tragfähige berufliche Wege nach Europa.",
      proofItems: [
        "Verifikation vor Matching",
      "Readiness vor Ankunft",
      "Transparenz statt Vermittlungslogik",
    ],
    primaryActions: [
      {
        label: "Für Arbeitgeber",
        href: "/register",
        variant: "primary",
      },
      {
        label: "Für Fachkräfte starten",
        href: "/applicant/frontdoor?entry=abroad",
        variant: "secondary",
      },
    ],
    secondaryActions: [
      {
        label: "System lesen",
        href: "#system",
      },
      {
        label: "Leitbild",
        href: "/leitbild",
      },
    ],
    stageCards: [
      {
        label: "Verfahrenslogik",
        title: "Aus unstrukturierten Unterlagen wird ein nachvollziehbarer Kandidaten- und Prozesskontext.",
        detail: "Dokumente, Readiness und nächste Schritte werden nicht gesammelt, sondern sauber geordnet.",
      },
      {
        label: "Arbeitgeberanspruch",
        title: "Teilnehmende Arbeitgeber werden nicht nur sichtbar, sondern in Verantwortung geführt.",
        detail: "Verbindliche Unterstützung, Transparenz und Integrationsbereitschaft sind Teil des Systems.",
      },
      {
        label: "Prozessstatus",
        title: "Profil, Nachweise, Sprache, Matching, Filing und Ankommen greifen wie eine gemeinsame Infrastruktur ineinander.",
        detail: "Das System bleibt ruhig in der Oberfläche und präzise in den Übergängen.",
      },
    ],
    stats: [
      {
        label: "Dokumente",
        value: "Verifiziert",
        caption: "Formale Nachweise werden strukturiert, geprüft und in Kontext gesetzt.",
      },
      {
        label: "Readiness",
        value: "Mehrdimensional",
        caption: "Sprache, Qualifikation, Vorbereitung und Integrationsfähigkeit werden zusammen betrachtet.",
      },
      {
        label: "Matching",
        value: "Verantwortlich",
        caption: "Arbeitgeber sehen keine losen Profile, sondern belastbare Signale für tragfähige Entscheidungen.",
      },
    ],
  },
  proofStripModule: {
    eyebrow: "Proof",
    lead:
      "Verifikation, Dokumentenprüfung, Readiness und Arbeitgeberverantwortung werden nicht erst am Ende sichtbar, sondern früh als operative Signale geführt.",
    items: [
      {
        title: "KI-gestützte Strukturierung",
        text: "Profile, Nachweise und Prozesssignale werden in eine verständliche Systemlogik überführt.",
      },
      {
        title: "Dokumenten-Verifikation",
        text: "Relevante Unterlagen werden sichtbar, einordenbar und prüfbar statt nur hochgeladen.",
      },
      {
        title: "Readiness statt Schnellschuss",
        text: "Sprachstand, Qualifikationsnähe und Vorbereitung fließen in die Bewertung ein.",
      },
      {
        title: "Verantwortliche Arbeitgeber",
        text: "Teilnahme bedeutet klare Pflichten bei Willkommenskultur, Wohnraum und Integration.",
      },
      {
        title: "Transparenz und Datenschutz",
        text: "Jeder Schritt folgt einer nachvollziehbaren Prozessarchitektur mit sauberem Rollenverständnis.",
      },
    ],
  },
  benefitCardsModule: {
    eyebrow: "Warum Experts4Europe",
    title: "Nicht Jobbörse. Nicht Agentur.\nSondern ein verantwortliches\nEinwanderungssystem.",
    lead:
      "Klassische Jobportale zeigen offene Stellen. Klassische Vermittlungen organisieren Kontakte. Experts4Europe schafft eine belastbare Infrastruktur, in der Vorbereitung, Verifikation, Matching und Integration zusammenspielen.",
    cards: [
      {
        icon: "scan",
        title: "Verifikation vor Versprechen",
        text: "Dokumente, Qualifikationen und Statusinformationen werden zuerst strukturiert und eingeordnet. So entstehen weniger Fehlannahmen auf beiden Seiten.",
      },
      {
        icon: "sparkles",
        title: "KI als Ordnungs- und Auswertungsschicht",
        text: "KI beschleunigt nicht blind, sondern macht Profile, Nachweise und Readiness systematisch lesbar.",
      },
      {
        icon: "languages",
        title: "Vorbereitung ist Teil des Produkts",
        text: "Sprache, Arbeitswelt, Integrationsrealität und Erwartungen gehören in den Weg hinein, nicht erst nach Vertragsabschluss.",
      },
      {
        icon: "building",
        title: "Arbeitgeber werden in Verantwortung geführt",
        text: "Willkommensprämie, Wohnraumunterstützung und transparente Teilnahmebedingungen sind keine Fußnote, sondern Systembestandteil.",
      },
      {
        icon: "workflow",
        title: "Aus Matching wird Verfahrenslogik",
        text: "Nach dem Match enden die Prozesse nicht. Filing, Vorbereitung und Ankommen werden mitgedacht.",
      },
      {
        icon: "scale",
        title: "Fairness bleibt messbar",
        text: "Würde, Transparenz und Respekt vor Qualifikation werden operationalisiert, statt nur behauptet.",
      },
    ],
  },
  processStoryModule: {
    eyebrow: "So funktioniert das System",
    title: "Ein klarer Ablauf statt vieler\nlose verbundener Schritte.",
    lead:
      "Die Plattform reduziert Komplexität nicht durch Verkürzung, sondern durch Struktur. Jeder Abschnitt erzeugt neue Belastbarkeit für den nächsten.",
    steps: [
      {
        step: "01",
        title: "Profil & Dokumente",
        description:
          "Persönliche Angaben, Berufsbilder, Nachweise und vorhandene Dokumente werden in einen belastbaren Ausgangspunkt überführt.",
        highlights: ["Profilkontext", "Dokumentenlage", "Vollständigkeit"],
        metricLabel: "Systemstatus",
        metricValue: "Ausgangslage sichtbar",
        panelTitle: "Candidate Record",
        panelText:
          "Aus losen Dokumenten entsteht ein strukturierter Kandidatenkontext mit prüfbaren Grundlagen.",
      },
      {
        step: "02",
        title: "Strukturierung & KI-Auswertung",
        description:
          "Die Plattform ordnet Unterlagen, erkennt Muster, markiert Lücken und bereitet die Informationen für menschliche Entscheidungen lesbar auf.",
        highlights: ["Signalextraktion", "Lückenanalyse", "Qualifikationskontext"],
        metricLabel: "Analyse",
        metricValue: "KI-gestützte Struktur",
        panelTitle: "Evidence Layer",
        panelText:
          "Relevante Nachweise werden nicht nur abgelegt, sondern nach Rolle, Qualität und Verfahrenstauglichkeit ausgewertet.",
      },
      {
        step: "03",
        title: "Sprache, Readiness & Qualifikationsstand",
        description:
          "Sprachstand, berufliche Anschlussfähigkeit, Vorbereitung und Integrationsfähigkeit werden zusammen betrachtet.",
        highlights: ["Sprache", "Readiness", "Berufliche Nähe"],
        metricLabel: "Readiness",
        metricValue: "Mehrdimensional bewertet",
        panelTitle: "Readiness Score",
        panelText:
          "Der Status beschreibt nicht nur Eignung, sondern den realistischen Vorbereitungsgrad für den europäischen Arbeitsmarkt.",
      },
      {
        step: "04",
        title: "Arbeitgeber-Matching",
        description:
          "Arbeitgeber sehen keine anonymen Massenprofile, sondern strukturierte, nachvollziehbare und verantwortbare Kandidatenkontexte.",
        highlights: ["Passung", "Transparenz", "Verantwortung"],
        metricLabel: "Matching",
        metricValue: "Auf belastbaren Signalen",
        panelTitle: "Employer View",
        panelText:
          "Die Arbeitgebersicht verbindet Qualifikation, Readiness, Nachweisqualität und Integrationsanforderungen in einem ruhigen Entscheidungsraum.",
      },
      {
        step: "05",
        title: "Filing, Vorbereitung & Ankommen",
        description:
          "Nach dem Match beginnt die operative Phase: Filing-Logik, Arbeitgeberpflichten, Anreisevorbereitung und erstes Ankommen werden strukturiert begleitet.",
        highlights: ["Filing", "Onboarding", "Integration"],
        metricLabel: "Transfer",
        metricValue: "Vom Match zum Start",
        panelTitle: "Arrival Flow",
        panelText:
          "Die Plattform endet nicht am Vertrag. Sie hält den Übergang in den europäischen Alltag prozessual zusammen.",
      },
    ],
  },
  systemShowcaseModule: {
    eyebrow: "System Showcase",
    title: "Produktausschnitte aus einer ruhig organisierten Systemoberfläche.",
    lead:
      "Die Oberfläche zeigt keine Lautstärke, sondern Ordnung. Jede Ebene reduziert Unsicherheit und macht Verantwortung sichtbar.",
    panels: [
      {
        icon: "users",
        eyebrow: "Kandidatenprofil",
        title: "Profile mit Kontext statt bloßer Datensätze",
        text: "Berufsbild, Qualifikationsnähe, Nachweise, Sprache und Fortschritt werden zusammen gelesen.",
        details: ["Berufliche Kernsignale", "Nachweisqualität", "Entwicklungsstand"],
      },
      {
        icon: "shield",
        eyebrow: "Dokumentenprüfung",
        title: "Verifikation als ruhige Kontrollschicht",
        text: "Das System markiert Status, Evidenz und offene Anforderungen in einer lesbaren Prüfarchitektur.",
        details: ["Prüfstatus", "Risikoflaggen", "Nachforderungslogik"],
      },
      {
        icon: "layers",
        eyebrow: "Readiness",
        title: "Mehrere Ebenen greifen ineinander",
        text: "Sprache, Vorbereitung, Berufsnähe und Integrationsfaktoren werden nicht isoliert bewertet.",
        details: ["Sprachstand", "Fachliche Anschlussfähigkeit", "Ankommensbereitschaft"],
      },
      {
        icon: "building",
        eyebrow: "Arbeitgebersicht",
        title: "Matching mit Verantwortung und Verfahrenstiefe",
        text: "Arbeitgeber erhalten klare Entscheidungsgrundlagen und sehen zugleich die eigenen Verpflichtungen im Prozess.",
        details: ["Fit-Signale", "Arbeitgeberpflichten", "Integrationsanforderungen"],
      },
      {
        icon: "waypoints",
        eyebrow: "Filing-Logik",
        title: "Von der Kandidatensicht in behördliche Abläufe",
        text: "Verfahrensrelevante Informationen werden für Vorbereitung, Übergabe und Nachverfolgung strukturiert gehalten.",
        details: ["Ablaufstatus", "Packlogik", "Übergabepunkte"],
      },
    ],
  },
  audienceSplitModule: {
    eyebrow: "Zwei Einstiege",
    title: "Zwei Perspektiven. Ein gemeinsames System.",
    audiences: [
      {
        icon: "building",
        eyebrow: "Operative Sicht",
        title: "Für Arbeitgeber",
        text:
          "Sie suchen keine Datenbank, sondern eine belastbare Rekrutierungs- und Integrationsinfrastruktur. Experts4Europe hilft, internationale Fachkräftegewinnung professioneller, transparenter und verantwortlicher zu organisieren.",
        points: [
          "Strukturierte Kandidatenkontexte statt unverbundener Bewerbungen",
          "Mehr Klarheit zu Readiness, Sprachstand und Nachweisqualität",
          "Verantwortungslogik für Welcome, Wohnraum und Integration",
        ],
        href: "/register",
        ctaLabel: "Arbeitgeber entdecken",
      },
      {
        icon: "users",
        eyebrow: "Orientierungspfad",
        title: "Für Fachkräfte",
        text:
          "Sie erhalten keinen beliebigen Recruiting-Flow, sondern einen geordneten Weg in den europäischen Arbeitsmarkt. Vorbereitung, Sichtbarkeit und faire Bedingungen bleiben Teil des Systems.",
        points: [
          "Direkter Zugang ohne klassische Vermittlungslogik",
          "Klare Orientierung zu Dokumenten, Sprache und Readiness",
          "Mehr Transparenz vor Bewerbung, Match und Ankommen",
        ],
        href: "/applicant/frontdoor?entry=abroad",
        ctaLabel: "Als Fachkraft starten",
      },
    ],
  },
  missionModule: {
    eyebrow: "Leitbild",
    title: "Warum dieses\nProjekt existiert.",
    lead:
      "Internationale Fachkräfteeinwanderung leidet oft nicht an fehlender Nachfrage, sondern an fehlender Ordnung, unklarer Verantwortung und einer Logik, die Geschwindigkeit über Vorbereitung stellt.",
    paragraphs: [
      "Experts4Europe korrigiert genau diese Fehlentwicklung. Das System schafft eine ruhigere Form internationaler Rekrutierung, in der Würde, Qualifikation, Nachvollziehbarkeit und Ankommen nicht nachgelagert werden.",
      "Für Fachkräfte bedeutet das: mehr Schutz, mehr Klarheit, mehr Vorbereitung und ein fairerer Zugang zu europäischen Arbeitgebern. Für Arbeitgeber bedeutet es: weniger Unsicherheit, bessere Entscheidungsgrundlagen und eine ernst gemeinte Integrationsverantwortung.",
      "Das Ziel ist kein laut vermarktetes Recruiting-Versprechen, sondern eine tragfähige Infrastruktur für faire berufliche Wege nach Europa.",
    ],
    quote:
      "Faire Einwanderung beginnt nicht beim Matching, sondern bei Vorbereitung, Verantwortung und nachvollziehbaren Übergängen.",
    principles: [
      "Fairness",
      "Würde",
      "Vorbereitung",
      "Verantwortung",
      "Integration",
      "Transparenz",
    ],
    antipatterns: [
      "Keine klassische Vermittlungslogik",
      "Keine Blackbox zwischen Profil und Entscheidung",
      "Keine unvorbereiteten Übergaben nach dem Match",
      "Keine Auslagerung von Integrationsverantwortung",
    ],
  },
  trustModule: {
    eyebrow: "Trust Architecture",
    title: "Vertrauen entsteht\naus Systemklarheit.",
    lead:
      "Die Plattform macht nicht nur Chancen sichtbar, sondern auch Voraussetzungen, Prüfpfade, Zuständigkeiten und Datenschutzlogik.",
    items: [
      {
        title: "Verifikation",
        text: "Dokumentenstatus und Nachweisqualität werden systematisch geführt, statt im Hintergrund zu verschwinden.",
      },
      {
        title: "Prozessklarheit",
        text: "Von Profil über Matching bis Filing bleibt sichtbar, welcher Schritt gerade belastbar vorbereitet ist.",
      },
        {
          title: "Arbeitgeber-\nverantwortung",
          text: "Teilnehmende Arbeitgeber akzeptieren klare Beiträge zu Welcome, Wohnraum und Integration.",
        },
      {
        title: "Transparenz",
        text: "Wichtige Signale, offene Lücken und relevante Pfade bleiben nachvollziehbar statt in Einzelfällen verborgen.",
      },
      {
        title: "Datenschutz",
        text: "Personenbezogene Daten werden nur entlang definierter Rollen und nachvollziehbarer Systemlogik verarbeitet.",
      },
    ],
    calloutTitle: "Vertrauen ohne Siegelästhetik",
    calloutText:
      "Experts4Europe setzt nicht auf eine banale Vertrauensleiste. Vertrauen entsteht hier aus Verfahrensstruktur, Verantwortung und kontrollierter Sichtbarkeit.",
  },
  faqModule: {
    eyebrow: "FAQ",
    title: "Wichtige Fragen vor dem Einstieg.",
    items: [
      {
        question: "Ist Experts4Europe eine Vermittlungsagentur?",
        answer:
          "Nein. Experts4Europe ist als strukturierende und KI-gestützte Infrastruktur gedacht, nicht als klassische Vermittlung. Die Plattform ordnet Profile, Nachweise, Readiness, Matching und weitere Prozessschritte in ein nachvollziehbares System ein.",
      },
      {
        question: "Was unterscheidet die Plattform von einer normalen Jobbörse?",
        answer:
          "Eine Jobbörse zeigt primär Stellen. Experts4Europe bildet zusätzlich Qualifikation, Dokumentenlage, Sprachstand, Vorbereitung, Arbeitgeberverantwortung und verfahrensrelevante Übergänge systematisch ab.",
      },
      {
        question: "Wie schützt Experts4Europe Fachkräfte?",
        answer:
          "Durch mehr Transparenz, klarere Voraussetzungen, strukturierte Dokumentenführung, verantwortliche Arbeitgeberbedingungen und einen Weg, der Vorbereitung nicht ausblendet.",
      },
      {
        question: "Welche Rolle spielt KI auf der Plattform?",
        answer:
          "KI unterstützt bei Ordnung, Strukturierung und Auswertung. Sie soll Komplexität lesbar machen, nicht menschliche Verantwortung ersetzen.",
      },
      {
        question: "Warum spielt Arbeitgeberverantwortung eine so große Rolle?",
        answer:
          "Weil nachhaltige internationale Fachkräftegewinnung nicht mit dem Matching endet. Welcome, Wohnraum, Onboarding und Integration entscheiden wesentlich über die reale Tragfähigkeit des Weges.",
      },
      {
        question: "Ist die Homepage schon für spätere Mehrsprachigkeit vorbereitet?",
        answer:
          "Ja. Die Content-Struktur ist modular aufgebaut und kann für lokalisierte Inhalte und zusätzliche Sprachen erweitert werden.",
      },
    ],
  },
  ctaModule: {
    eyebrow: "Nächster Schritt",
    title: "Faire Einwanderung braucht Struktur, nicht Lautstärke.",
    text:
      "Wenn internationale Fachkräfteeinwanderung fair, vorbereitet und verantwortungsvoll funktionieren soll, braucht sie eine ruhige, belastbare Systemoberfläche. Genau daran arbeitet Experts4Europe.",
    actions: [
      {
        label: "Arbeitgeber entdecken",
        href: "/register",
        variant: "primary",
      },
      {
        label: "Als Fachkraft starten",
        href: "/applicant/frontdoor?entry=abroad",
        variant: "secondary",
      },
      {
        label: "Leitbild lesen",
        href: "/leitbild",
        variant: "tertiary",
      },
    ],
  },
};

export default homepageFallback;
